import React from 'react';
import { useAuth } from './AuthProvider';
import Login from './Login';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  
  if (!user) {
    return <Login />;
  }
  
  return children;
};

export default ProtectedRoute;
